const MFA_STORAGE_KEY = 'mfa'

export function clearMfaState() {
    sessionStorage.removeItem(MFA_STORAGE_KEY)
}

export function getMfaState() {
    const value = sessionStorage.getItem(MFA_STORAGE_KEY)

    if (!value) {
        return null
    }

    try {
        return JSON.parse(value)
    } catch (_) {
        clearMfaState()
        return null
    }
}

export function setMfaState(state) {
    sessionStorage.setItem(MFA_STORAGE_KEY, JSON.stringify(state))
}

export function selectMfaMethod(type) {
    const state = getMfaState()

    if (!state) {
        return null
    }

    state.selectedMethod = type
    setMfaState(state)

    return state
}

export function saveMfaChallenge(type, challenge) {
    const state = getMfaState()

    if (!state) {
        return null
    }

    state.challenges = state.challenges || {}
    state.challenges[type] = challenge
    setMfaState(state)

    return state
}

export const _ = undefined
